export default "__VITE_ASSET__BFhhNVv2__"